/* KayaVedic Theme JS */
document.addEventListener('DOMContentLoaded', function () {
  /* ---- Mobile menu ---- */
  var toggle = document.querySelector('.menu-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  /* ---- Hero slider ---- */
  document.querySelectorAll('.hero-slider').forEach(function (slider) {
    var track = slider.querySelector('.hero-slider__track');
    var slides = slider.querySelectorAll('.hero-slide');
    var dots = slider.querySelectorAll('.hero-slider__dots button');
    var autoplay = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval || '5', 10) * 1000;
    var i = 0, timer;
    if (slides.length < 2) return;

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + i * 100 + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { if (autoplay) timer = setInterval(function () { go(i + 1); }, interval); }
    function reset() { clearInterval(timer); start(); }

    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); reset(); }); });
    var prev = slider.querySelector('.hero-slider__arrow--prev');
    var next = slider.querySelector('.hero-slider__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(i - 1); reset(); });
    if (next) next.addEventListener('click', function () { go(i + 1); reset(); });

    /* touch swipe */
    var x0 = null;
    slider.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); reset(); }
      x0 = null;
    }, { passive: true });

    start();
  });

  /* ---- Product gallery thumbs ---- */
  /* FIX: was querySelector('[data-main-image]') but the img has id="MainProductImage" */
  var mainImg = document.getElementById('MainProductImage');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = t.dataset.full;
      document.querySelectorAll('[data-thumb]').forEach(function (o) { o.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  /* ---- Keep sticky add-to-cart bar in sync with the chosen variant ---- */
  /* FIX: was select[name="id"] but form uses radio inputs, not a <select> */
  var stickyVariant = document.querySelector('[data-sticky-atc] input[name="id"]');
  if (stickyVariant) {
    document.querySelectorAll('.product-page form input[type="radio"][name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        stickyVariant.value = this.value;
      });
    });
  }

  /* ---- Track order form ---- */
  var trackForm = document.querySelector('[data-track-form]');
  if (trackForm) {
    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var awb = trackForm.querySelector('input').value.trim();
      var base = trackForm.dataset.trackUrl || 'https://www.delhivery.com/tracking';
      if (awb) {
        var sep = base.indexOf('?') > -1 ? '&' : '?';
        window.open(base + sep + 'wbn=' + encodeURIComponent(awb), '_blank');
      } else {
        window.open(base, '_blank');
      }
    });
  }

  /* ---- Ajax add to cart (keeps user on page) ---- */
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn.textContent;
      btn.textContent = 'Adding…'; btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (item) {
          /* Meta Pixel: AddToCart */
          if (typeof fbq !== 'undefined') {
            fbq('track', 'AddToCart', {
              content_ids: [String(item.product_id)],
              content_name: item.product_title,
              content_type: 'product',
              value: (item.price / 100).toFixed(2),
              currency: 'INR'
            });
          }
          return fetch('/cart.js');
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          btn.textContent = 'Added ✓';
          setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
        })
        .catch(function () { btn.textContent = original; btn.disabled = false; form.submit(); });
    });
  });
});

/* ---- Meta Pixel: AddToCart on Buy Now (product cards) ---- */
document.querySelectorAll('.doxwell-buy-now-form').forEach(function (form) {
  form.addEventListener('submit', function () {
    if (typeof fbq !== 'undefined') {
      fbq('track', 'AddToCart', {
        content_ids: [form.dataset.pixelProductId],
        content_name: form.dataset.pixelProductTitle,
        content_type: 'product',
        value: parseFloat(form.dataset.pixelPrice) || 0,
        currency: 'INR'
      });
    }
  });
});

/* ---- Offer countdown ---- */
document.querySelectorAll('.offer-timer').forEach(function (el) {
  var end = new Date((el.dataset.end || '').replace(' ', 'T'));
  if (isNaN(end)) return;
  var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'),
      m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var diff = end - Date.now();
    if (diff <= 0) { el.classList.add('is-ended'); clearInterval(t); return; }
    d.textContent = pad(Math.floor(diff / 86400000));
    h.textContent = pad(Math.floor(diff / 3600000) % 24);
    m.textContent = pad(Math.floor(diff / 60000) % 60);
    s.textContent = pad(Math.floor(diff / 1000) % 60);
  }
  var t = setInterval(tick, 1000); tick();
});

/* ---- Sticky add-to-cart (mobile) — show after scrolling past main button ---- */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  /* FIX: was '.product-page form .btn' but submit button class is 'btn-order-now' */
  var mainBtn = document.querySelector('.product-page form .btn-order-now');
  if (!bar || !mainBtn || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    bar.classList.toggle('is-visible', !entries[0].isIntersecting);
  }, { threshold: 0 }).observe(mainBtn);
})();

/* ---- Shorts strip: autoplay in view, tap to unmute ---- */
(function () {
  var vids = document.querySelectorAll('[data-shorts-video]');
  if (!vids.length) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.play().catch(function () {}); }
        else { en.target.pause(); }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { io.observe(v); });
  }
  document.querySelectorAll('[data-shorts-sound]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.parentElement.querySelector('video');
      v.muted = !v.muted;
      btn.querySelector('.icon-muted').style.display = v.muted ? '' : 'none';
      btn.querySelector('.icon-sound').style.display = v.muted ? 'none' : '';
      btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
      if (!v.muted) v.play().catch(function () {});
    });
  });
})();
